var _ = require('underscore');
module.exports = function(data){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='<div class="signup-text desktop-content">Get a page and a domain with your name.</div>\n<div class="actions">\n    <a href="/welcome" class="button large dark primary">\n        <span class="desktop-content">Get started for free</span>\n        <span class="mobile-content">Get your page</span>\n    </a>\n</div>\n';
return __p;
};
